import React from 'react';
import { Field } from 'redux-form';
import { renderTextField, requiredValidator, renderSelect, renderRadioGroup, industrySelect, INDUSTRIES } from 'utils/formHelper';
import Header from 'components/Header';

export default class BorrowerDetails extends React.Component {
  render = () => {
    console.log('this', this.props)
    return (
      <div>
        <div className='form-row' >
          <Field
            name='name'
            component={renderTextField}
            label='Full Name'
            validate={requiredValidator}
          />
          <Field
            name='abn'
            component={renderTextField}
            label='ABN or ACN'
            validate={requiredValidator}
          />
          <Field
            name='businessName'
            component={renderTextField}
            validate={requiredValidator}
            label='Registered Business Name'
          />
          <Field
            name='businessType'
            options={['', 'Sole Proprietor', 'Partnership', 'Public Company', 'Trustee Company', 'Association', 'Pty Ltd', 'Other']}
            component={renderSelect}
            label='Type of Business Entity'
          />
          <Field
            name='website'
            component={renderTextField}
            label='Website'
          />
          <Field
            name='outstandingLiabilityPayments'
            component={renderRadioGroup}
            normalize={(value) => (JSON.parse(value))}
            options={[{key: 'Yes', value: 'true'}, {key: 'No', value: 'false'}]}
            label='Do you the borrower(s) have any outstanding liabilities for taxes or other statutory payments (eg. GST, Group Tax, Superannuation etc)'
          />
          <Field
            name='pendingLegalAction'
            component={renderRadioGroup}
            normalize={(value) => (JSON.parse(value))}
            options={[{key: 'Yes', value: 'true'}, {key: 'No', value: 'false'}]}
            label='Is there any legal action pending or in progress in relation to you, the borrower(s) or the business or which may affect the business (eg. Creditor action, administrator/liquidator appointment etc)'
          />
          <Field
            name='capacityToRepay'
            component={renderRadioGroup}
            normalize={(value) => (JSON.parse(value))}
            options={[{key: 'Yes', value: 'true'}, {key: 'No', value: 'false'}]}
            label='Do the borrower(s) have the capacity to repay all current credit obligations in addition to the proposed obligations as docmented in this application?'
          />

          <Field
            name='existingBusinessFacilities'
            component={renderTextField}
            label='Existing and requested business facilities'
          />
          <Field
            name='numberOfEmployees'
            component={renderTextField}
            label='Number of employees'
          />
          <Header heading='Business Address' />
          <Field
            name='businessAddress.streetAddress'
            component={renderTextField}
            label='Street Address'
            validate={requiredValidator}
          />
          <Field
            name='businessAddress.city'
            component={renderTextField}
            label='City'
            validate={requiredValidator}
          />
          <Field
            name='businessAddress.postcode'
            component={renderTextField}
            label='Postcode'
            validate={requiredValidator}
          />
          <Field
            name='businessAddress.state'
            component={renderTextField}
            label='State'
            validate={requiredValidator}
          />
          <Field
            name='industry'
            component={industrySelect}
            label="Industry"
            options={INDUSTRIES}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/BorrowerDetails.js